<template>
    <header :class="['admin-header' ]" ref="admin-header">
<!--        {'scrolled': isScrolled} -->
        <div class="admin-container">
            <div class="content">
                <router-link to="/" class="logo">
                    <svg width="36" height="29" viewBox="0 0 36 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M23.4245 9.03549L35.5 10.8969L18.6916 28.8488L0.5 9.03549L7.12796 0.151169H22.5723L23.4245 9.03549ZM14.1593 18.0934L18.7197 23.0604L27.5302 13.6505L21.6307 12.741L14.1593 18.0934ZM5.60399 8.77538L11.478 15.1729L19.5076 9.4206L19.5068 9.41122L18.9961 4.08678H9.10207L5.60399 8.77538Z" fill="black"/>
                        <path d="M22.5723 0.151169L23.4245 9.03549L35.5 10.8969L18.6916 28.8488L0.5 9.03549L7.12796 0.151169H22.5723ZM1.11248 9.00413L18.695 28.1541L34.5435 11.2273L22.9894 9.44627L22.1432 0.623442H7.36487L1.11248 9.00413Z" fill="#D4D4D4"/>
                    </svg>
                </router-link>
                <div class="right">
                    <div class="profile">
                        <div class="profile-icon">
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M3.85 15.1C4.7 14.45 5.65 13.9377 6.7 13.563C7.75 13.1883 8.85 13.0007 10 13C11.15 13 12.25 13.1877 13.3 13.563C14.35 13.9383 15.3 14.4507 16.15 15.1C16.7333 14.4167 17.1877 13.6417 17.513 12.775C17.8383 11.9083 18.0007 10.9833 18 10C18 7.78333 17.221 5.89567 15.663 4.337C14.105 2.77833 12.2173 1.99933 10 2C7.78333 2 5.89567 2.77933 4.337 4.338C2.77833 5.89667 1.99933 7.784 2 10C2 10.9833 2.16267 11.9083 2.488 12.775C2.81333 13.6417 3.26733 14.4167 3.85 15.1ZM10 11C9.01667 11 8.18733 10.6627 7.512 9.988C6.83667 9.31333 6.49933 8.484 6.5 7.5C6.5 6.51667 6.83767 5.68733 7.513 5.012C8.18833 4.33667 9.01733 3.99933 10 4C10.9833 4 11.8127 4.33767 12.488 5.013C13.1633 5.68833 13.5007 6.51733 13.5 7.5C13.5 8.48333 13.1627 9.31267 12.488 9.988C11.8133 10.6633 10.984 11.0007 10 11ZM10 20C8.61667 20 7.31667 19.7373 6.1 19.212C4.88333 18.6867 3.825 17.9743 2.925 17.075C2.025 16.175 1.31267 15.1167 0.788 13.9C0.263333 12.6833 0.000666667 11.3833 0 10C0 8.61667 0.262667 7.31667 0.788 6.1C1.31333 4.88333 2.02567 3.825 2.925 2.925C3.825 2.025 4.88333 1.31267 6.1 0.788C7.31667 0.263333 8.61667 0.000666667 10 0C11.3833 0 12.6833 0.262667 13.9 0.788C15.1167 1.31333 16.175 2.02567 17.075 2.925C17.975 3.825 18.6877 4.88333 19.213 6.1C19.7383 7.31667 20.0007 8.61667 20 10C20 11.3833 19.7373 12.6833 19.212 13.9C18.6867 15.1167 17.9743 16.175 17.075 17.075C16.175 17.975 15.1167 18.6877 13.9 19.213C12.6833 19.7383 11.3833 20.0007 10 20ZM10 18C10.8833 18 11.7167 17.871 12.5 17.613C13.2833 17.355 14 16.984 14.65 16.5C14 16.0167 13.2833 15.646 12.5 15.388C11.7167 15.13 10.8833 15.0007 10 15C9.11667 15 8.28333 15.1293 7.5 15.388C6.71667 15.6467 6 16.0173 5.35 16.5C6 16.9833 6.71667 17.3543 7.5 17.613C8.28333 17.8717 9.11667 18.0007 10 18ZM10 9C10.4333 9 10.7917 8.85833 11.075 8.575C11.3583 8.29167 11.5 7.93333 11.5 7.5C11.5 7.06667 11.3583 6.70833 11.075 6.425C10.7917 6.14167 10.4333 6 10 6C9.56667 6 9.20833 6.14167 8.925 6.425C8.64167 6.70833 8.5 7.06667 8.5 7.5C8.5 7.93333 8.64167 8.29167 8.925 8.575C9.20833 8.85833 9.56667 9 10 9Z" fill="#1C1C1C"/>
                            </svg>
                        </div>
                        <p class="profile-name">Name</p>
                    </div>
                    <div class="exit-btn btn"><router-link to="/">На сайт</router-link></div>
                </div>
            </div>
        </div>
    </header>
</template>

<script>
export default {
    name: 'Admin header',
    data() {
        return {
            headerHeight: 0,
            scrollHeight: 0
        };
    },
    computed: {
        // isScrolled() {
        //     return this.scrollHeight > this.headerHeight;
        // }
    },
    methods: {
      // handleScroll() {
      //     this.scrollHeight = parseInt(document.documentElement.scrollTop) + "1"
      // }
    },
    mounted() {
        this.headerHeight = parseInt(getComputedStyle(this.$refs["admin-header"]).height);
        document.addEventListener("scroll", this.handleScroll)
    }
}
</script>

<style scoped lang="scss">
@use '~@/assets/styles/vars' as *;
.admin-header {
        width: 100%;

        display: flex;
        align-items: center;
        height: 60px;
        background: $white;
        box-sizing: border-box;
        border-bottom: 1px solid $gray;

        font-size: 14px;
        font-weight: 400;
    }

    .admin-header.scrolled {
        position: fixed;
    }

    .admin-header .content {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
    }

    //.admin-header .logo {
    //    display: flex;
    //    justify-content: center;
    //    align-items: center;
    //    width: 130px;
    //    height: 30px;
    //    background: $gray;
    //    text-transform: uppercase;
    //    font-size: 12px;
    //    font-weight: 600;
    //}

    .admin-header .logo {
        cursor: pointer;
    }

    .admin-header .right {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        gap: 20%;
        //min-width: fit-content;
        width: auto;
        min-width: 200px;
    }

    .admin-header .right > * {
        max-width: 100%;
    }

    .admin-header .exit-btn {
        background: $gray;
        padding: 8%;
        display: flex;
        align-items: center;
        border-radius: 10px;
        text-wrap: nowrap;
        white-space: nowrap;
        height: 30px;
        box-sizing: border-box;
    }

    .profile {
        display: flex;
        gap: 10px;
        align-items: center;
    }
</style>
